module.exports = __webpack_public_path__ + "img/home_recharge.b46d5fe6.png";